import { useCallback, useRef } from "react";

import { isTruthy } from "@dashboard/library";

import { TranscriptionItemUtteranceEntry } from "../TranscriptionItemUtteranceEntry/TranscriptionItemUtteranceEntry";

import { TranscriptionItemUtteranceProps } from "./TranscriptionItemUtterance.decl";
import * as S from "./TranscriptionItemUtterance.styled";

import { useRegister } from "@/hooks/useRegister/useRegister";
import { useTranscriptionRule } from "@/hooks/useTranscriptionRules/useTranscriptionRules";
import { useBaseStore } from "@/store/store";

export function TranscriptionItemUtterance({
  active,
  entries,
  currentTime,
  index,
}: TranscriptionItemUtteranceProps) {
  const { isRealTimeTranscription } = useTranscriptionRule();
  const searchContentMatches = useBaseStore(
    (store) => store.searchContentMatches
  );
  const matchedUtterance = searchContentMatches?.get(index);

  const isWordMatched = useCallback(
    (word: string) =>
      !!matchedUtterance?.terms
        .filter(isTruthy)
        .some((term) => word.toLowerCase().includes(term.toLowerCase())),
    [matchedUtterance?.terms]
  );
  const utteranceRef = useRef<HTMLDivElement>(null);
  useRegister(utteranceRef, index);

  return (
    <S.Utterance ref={utteranceRef} data-dd-privacy="mask">
      {entries.map(({ W: w, S: s }, i) => (
        <TranscriptionItemUtteranceEntry
          key={i}
          w={w}
          matched={isWordMatched(w)}
          startTime={s}
          active={active}
          currentTime={currentTime}
          isRealTimeTranscription={isRealTimeTranscription}
        />
      ))}
    </S.Utterance>
  );
}
